import { createStore } from 'vuex';
import { config } from 'vuex-module-decorators';

import AppConfigurationModule from '@/store/modules/AppConfigurationModule';
import AuthModule from '@/store/modules/AuthModule';
import AuthzModule from '@/store/modules/AuthzModule';
import BodyModule from '@/store/modules/BodyModule';
import BreadcrumbsModule from '@/store/modules/BreadcrumbsModule';
import ConfigModule from '@/store/modules/ConfigModule';
import ThemeModeModule from '@/store/modules/ThemeModeModule';
import ConfirmationDialogModule from '@/store/modules/ConfirmationDialogModule';
import UserSystemSettingsModule from '@/store/modules/UserSystemSettingsModule';
import DashboardModule from '@/store/modules/DashboardModule';

config.rawError = true;

const store = createStore({
  modules: {
    AppConfigurationModule,
    AuthModule,
    AuthzModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    ThemeModeModule,
    ConfirmationDialogModule,
    UserSystemSettingsModule,
    DashboardModule,
  },
});

export default store;
